"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsList.title': 'Agentes de Comunicación',
    'whatsapp.settingsList.add': 'Añadir número de teléfono',
    'whatsapp.settingsList.empty': 'No hay números configurados. Añade uno para empezar.',
    'whatsapp.settingsList.language': 'Idioma',
    'whatsapp.settingsList.avatar': 'Avatar',
    'whatsapp.settingsList.actions': 'Acciones',
    'whatsapp.settingsList.loadFailed': 'No se pudieron cargar las configuraciones de WhatsApp.',
    'whatsapp.settingsList.deleteConfirm': '¿Estás seguro de que quieres eliminar esta configuración de WhatsApp?',
    'whatsapp.settingsList.deleted': 'Configuración de WhatsApp eliminada.',
    'whatsapp.settingsList.deleteFailed': 'No se pudo eliminar la configuración de WhatsApp.',
};
